// extracted by mini-css-extract-plugin
export default {"container":"tp-z","brandName":"up-z","productName":"vp-z","productNamePdpEnhancements":"wp-z","breakLongProductName":"xp-z"};